export enum UserPermissions {
    CreateCsqa = 'createCsqa',
    DeleteCsqa = 'deleteCsqa',
    EditCsqa = 'editCsqa',
    GetCsqa = 'getCsqa',
    SearchCsqa = 'searchCsqa',
    SearchAgentCsqa = 'searchAgentCsqa',
    ViewCsqa = 'viewCsqa',

    AdminViewCoaching = 'adminViewCoaching',
    ApproveCoaching = 'approveCoaching',
    CreateCoaching = 'createCoaching',
    DeleteCoaching = 'deleteCoaching',
    DeliverCoaching = 'deliverCoaching',
    EditCoaching = 'editCoaching',
    GetCoaching = 'getCoaching',
    HrCoaching = 'hrCoaching',
    HrViewCoaching = 'hrViewCoaching',
    LeadViewCoaching = 'leadViewCoaching',
    ReworkCoaching = 'reworkCoaching',
    SearchCoaching = 'searchCoaching',
    ViewCoaching = 'viewCoaching',
}